<template>
  <div class="
      cbg-white-container
      p-0
      admin-chat
      input-container
      theme--light
      v-card
      p-16
      border-card
    ">
    <div class="col-sm-12 row ml-0">
      <div class="form-group col-sm-12 p-0">
        <div class="col-sm-12 border-bottom pl-0">
          <h5 class="text-dark mb-0">
            <b>{{ user_id }}</b> <small class="ml-1">{{ user_role }}</small>
          </h5>
        </div>
        <div class="col-sm-12 p-0">
          <div class="chat-message-div" ref="chatScroller" @scroll="handleScroll">
            <div v-for="messages in processedMessages" :key="messages.date">

              <div class="chat-date-div mx-auto">
                {{ messages | dateLocalization }} <!-- <p class="mb-0 text-dark">12-01-2020</p> -->
              </div>
              <div v-for="(chat_message, index) in messages.messages" :key="index">
                <div class="sent-message" v-if="userDetails._id != chat_message.original_sent_by">
                  <div class="message-div" v-if="chat_message.category == 'message'">
                    <p class="mb-0 text-dark" v-html="chat_message.text" v-linkified></p>
                    <small class="text-dark text-uppercase">{{
                      chat_message.created_at | timeFormat
                    }}</small>
                  </div>
                  <div class="image-div" v-else-if="chat_message.category == 'image'">
                    <image-view :src="chat_message.storage_url"></image-view>
                    <small class="text-dark text-uppercase">{{
                      chat_message.created_at | timeFormat
                    }}</small>
                  </div>
                  <div class="pdf-div" v-else-if="chat_message.category == 'attachment'">
                    <div class="pdf-details">
                      <div>
                        <pdfSVG />
                      </div>
                      <div>
                        <p class="mb-0 text-dark">lorem.pdf</p>
                        <a class="text-dark">Click here for download</a>
                      </div>
                    </div>
                    <small class="text-dark text-uppercase">{{
                      chat_message.created_at | timeFormat
                    }}</small>
                  </div>
                </div>
                <div class="received-message" v-else>
                  <div class="message-div" v-if="chat_message.category == 'message'">
                    <p class="mb-0 text-dark" v-html="chat_message.text" v-linkified></p>
                    <small class="text-dark text-uppercase">{{
                      chat_message.created_at | timeFormat
                    }}</small>
                  </div>
                  <div class="image-div" v-else-if="chat_message.category == 'image'">
                    <image-view :src="chat_message.storage_url"></image-view>
                    <small class="text-dark text-uppercase">{{
                      chat_message.created_at | timeFormat
                    }}</small>
                  </div>
                  <div class="pdf-div" v-else-if="chat_message.category == 'attachment'">
                    <div class="pdf-details">
                      <div>
                        <pdfSVG />
                      </div>
                      <div>
                        <p class="mb-0 text-dark" v-html="chat_message.text" v-linkified></p>
                        <a class="text-dark" @click="downloadS3Upload(chat_message.storage_url)">Click here for
                          download</a>
                      </div>
                    </div>
                    <small class="text-dark text-uppercase">{{
                      chat_message.created_at | timeFormat
                    }}</small>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 py-0">
      <textarea type="text" class="form-control" placeholder="Write something..." v-model="text"
        @keyup.enter="sendMessage" @focus="$emit('focussed')"></textarea>
      <div class="chat-action p-2 d-flex justify-content-between">
        <label class="attach">
          <file-upload class="fade" :refName="'upload'" :module="'admin'" :role="'system'" :drop="true" :multiple="true"
            @uploaded="uploadFile" :uploadFileToServer="uploadAttachment" id="fileUpload" ref="upload" hidden
            style="display: none !important"></file-upload>
          <!-- <input id="fileUpload" type="file" @change="uploadFile" hidden> -->

          <attachmentSVG />
          <!-- <image-view :src="'/img/avatars/Oc-attach.png'"></image-view> -->
          <!-- <img src="/img/Oc-attach.png" alt="attach" /> -->
        </label>
        <div class="send-svg" v-if="permissions.includes('CAN_CHAT')" @click="sendMessage">
          <sendSVG />
        </div>
      </div>
      <!-- <div
        v-if="permissions.includes('CAN_CHAT')"
        @click="sendMessage"
      >
        Send
      </div>-->
    </div>
  </div>
</template>

<script>
import config from "@/config.js";
import { bus } from "@/main.js";
const Image = () => import("@/components/image.vue");
const Pdf = () => import("@/components/pdf.vue");
import { pickSvg } from "@/views/SVG";
import "@/assets/scss/_chat.scss";
import dayjs from "dayjs";
import FileUpload from "@/components/FileUpload";
import { mapGetters } from "vuex";
import round from "lodash/round";
import linkify from "vue-linkify";

export default {
  directives: {
    linkified: linkify,
  },
  computed: {

    processedMessages: function () {
      let processed = {};
      let lastDate = null;
      this.chat_messages.forEach((m, mKey) => {
        let messageDate = dayjs(m.created_at).format("MMMM D YYYY");
        m.mKey = mKey;
        if (lastDate === null) {
          lastDate = messageDate;
        } else if (lastDate != messageDate) {
          lastDate = messageDate;
        }

        if (!processed[lastDate]) {
          processed[lastDate] = {
            date: lastDate,
            messages: [m]
          };
        } else processed[lastDate].messages.push(m);
      });
      return Object.values(processed);
    },
    ...mapGetters({
      permissions: "getPermissions",
      userDetails: "getUserDetails",
    }),
  },
  data() {
    return {
      text: "",
      chat_messages: [],
      chat_id: this.$route.params.chatId,
      user_id: this.$route.params.user_name,
      user_role: "",
      total_page: 1,
      current_page: 1,
      uploadAttachment: true,
    };
  },
  components: {
    ...pickSvg("pdfSVG", "sendSVG", "attachmentSVG"),
    "image-view": Image,
    "pdf-view": Pdf,
    FileUpload,
  },
  filters: {
    timeFormat(val) {
      return dayjs(val).format("h:m a");
    },
    dateLocalization(d) {
      const givenDate = d.date;
      const date1 = dayjs(givenDate, "MMMM Do YYYY");
      const date2 = dayjs();
      let hours = date2.diff(date1, 'hours');
      const days = Math.floor(hours / 24);
      switch (days) {
        case 0:
          return `Today`;
        case 1:
          return `Yesterday`;
        default:
          return `${givenDate}`;
      }
    }
  },
  created() {
    bus.$emit("CHAT_BREADCRUMB_CHANGE", [
      {
        text: "Home",
        disabled: !this.permissions.includes("VIEW_DASHBOARD"),
        to: "/dashboard",
      },
      {
        text: "Chat",
        disabled: false,
        to: "/chats",
      },
      {
        text: this.$route.params.user_name,
        disabled: true,
        to: this.$route.path,
      },
    ]);

    console.log("started listening to HANDLE_SYSTEM_CHAT_MESSAGE");
    bus.$on("SYSTEM_CHAT_MESSAGE", (data) => {
      let original_sent_by = data.sent_by._id;
      data.original_sent_by = original_sent_by;
      this.chat_messages.push(data);
      if (this.userDetails._id == data.original_sent_by) {
        this.scrollToBottom();
      } else {
        if (
          this.$refs.chatScroller.clientHeight +
          round(this.$refs.chatScroller.scrollTop) ==
          this.$refs.chatScroller.scrollHeight
        ) {
          this.scrollToBottom();
        }
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    bus.$emit("CHAT_BREADCRUMB_CHANGE", []);
    next();
  },
  beforeDestroy() {
    console.log("stopped listening to HANDLE_SYSTEM_CHAT_MESSAGE");
    bus.$off("SYSTEM_CHAT_MESSAGE");
  },
  mounted() {
    this.getChatMessages(1);
  },
  methods: {
    uploadFile(files, uploaded, fileName) {
      if (uploaded) {
        files.forEach((file, index) => {
          let extension = fileName[index].split(".").pop();
          if (["jpg", "jpeg", "png", "webp"].includes(extension)) {
            this.hitMessage(fileName[index], "image", file);
          } else {
            this.hitMessage(fileName[index], "attachment", file);
          }
        });
      }
    },
    downloadS3Upload(s3Url) {
      let splittedURl = s3Url.split("amazonaws.com/");
      if (!splittedURl[1]) {
        return;
      }
      window.open(`${config.BASE_URL}api/s3Upload?file_name=${splittedURl[1]}`);
    },
    handleScroll(e) {
      if (e.srcElement.scrollTop <= 3) {
        this.current_page++;
        if (this.current_page > this.total_page) {
          return;
        }
        this.getChatMessages(this.current_page);
      }
    },
    changePage(page) {
      this.getChatMessages(page);
    },
    getChatMessages(page) {
      let params = { page };
      this.$http
        .get(
          `${config.BASE_URL}api/v2/admin/system-chats/${this.chat_id}/messages`,
          {
            params,
          }
        )
        .then((response) => {
          if (response.body.status) {
            console.log(response)

            if (response.body.data.page > 1) {
              let msg = [...response.body.data.list, ...this.chat_messages];
              this.chat_messages = msg;
            } else {
              this.chat_messages = response.body.data.list;
            }
            this.user_role = response.body.data.receiver_role
            this.total_page = response.body.data.total;
            this.current_page = response.body.data.page;
            this.scrollToBottom();

            bus.$emit("CHAT_BREADCRUMB_CHANGE", [
              {
                text: "Home",
                disabled: !this.permissions.includes("VIEW_DASHBOARD"),
                to: "/dashboard",
              },
              {
                text: "Chat",
                link: true,
                exact: true,
                disabled: false,
                to: "/chats",
              },
              {
                text: this.user_role ? `${this.$route.params.user_name} (${this.user_role})` : this.$route.params.user_name,
                disabled: true,
                to: this.$route.path,
              },
            ]);
          }
        });
    },

    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.chatScroller.scrollTop =
          this.$refs.chatScroller.scrollHeight;
        this.scrollTopPosittion = this.$refs.chatScroller.scrollTop;
      });
    },
    sendMessage() {
      this.hitMessage(this.text, "message");
    },
    hitMessage(message, category, storageUrl, storageFileSize) {
      if (!message.trim()) {
        return;
      }
      message = message.trim();
      let body = {
        message,
        category,
        storage_url: storageUrl,
        storage_file_size: storageFileSize,
      };

      if (this.reply) {
        body.reply_id = this.reply._id;
      }
      this.$http
        .post(
          `${config.BASE_URL}api/v2/admin/system-chats/${this.chat_id}/messages`,
          body
        )
        .then((res) => {
          this.reply = null;
          this.text = null;
        });
    },
  },
};
</script>
